module.exports = "/assets/data/70c467d622b5a7ba7d1fbf762dd675d7-RG17.data.json";